var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47826 8.86957C3.60835 8.86957 2.08696 7.34817 2.08696 5.47826C2.08696 3.60835 3.60835 2.08696 5.47826 2.08696C7.34817 2.08696 8.86957 3.60835 8.86957 5.47826C8.86957 7.34817 7.34817 8.86957 5.47826 8.86957ZM11.6943 10.2188L10.0174 8.54191C10.6101 7.66696 10.9565 6.61252 10.9565 5.47826C10.9565 2.45739 8.49913 0 5.47826 0C2.45739 0 0 2.45739 0 5.47826C0 8.49913 2.45739 10.9565 5.47826 10.9565C6.61252 10.9565 7.66696 10.6101 8.54191 10.0174L10.2188 11.6943C10.4223 11.8983 10.6894 12 10.9565 12C11.2237 12 11.4908 11.8983 11.6943 11.6943C12.1017 11.2868 12.1017 10.6263 11.6943 10.2188Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0c39fbd6.svg";
export { ForwardRef as ReactComponent };